import { useEffect, useRef } from 'react';

const useReadFragmentFromUrl = () => {
  const fragmentRef = useRef<string | null>(null);

  useEffect(() => {
    const hash = window.location.hash || '';
    const match = /e=([^&]+)/.exec(hash.replace('#', ''));
    const exchangeTicket = match ? decodeURIComponent(match[1]) : null;
    fragmentRef.current = exchangeTicket;

    if (exchangeTicket) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }, []);

  return { fragmentRef };
};

export default useReadFragmentFromUrl;
